import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import spendTypeService from '../services/spendTypeService';

const spendTypesCollectionName = 'spend_types';
export const useSpendType = () => {
  return useQuery({
    queryKey: [spendTypesCollectionName],
    queryFn: () => spendTypeService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddSpendType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: spendTypeService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [spendTypesCollectionName] });
    },
  });
};

export const useEditSpendType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: spendTypeService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [spendTypesCollectionName] });
    },
  });
};

export const useDeleteSpendType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: spendTypeService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [spendTypesCollectionName] });
    },
  });
};

export const useSpendTypeNameById = (spendTypeId) => {
  return useQuery({
    queryKey: [spendTypesCollectionName, spendTypeId],
    queryFn: () => spendTypeService.getNameById(spendTypeId),
    enabled: !!spendTypeId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useEventTypeSpendTypes = (EventTypeId) => {
  return useQuery({
    queryKey: [spendTypesCollectionName, EventTypeId],
    queryFn: () => spendTypeService.geteventTypeSpendTypes(EventTypeId),
    enabled: !!EventTypeId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

